// All site copy in Turkish (tr) and English (en).
// Language-neutral tokens (tech names, skill levels) are duplicated as-is.

export const translations = {
  tr: {
    nav: {
      items: [
        { name: 'Hakkımda', to: 'about', n: '01' },
        { name: 'Yetkinlikler', to: 'skills', n: '02' },
        { name: 'Projeler', to: 'projects', n: '03' },
        { name: 'Deneyim', to: 'experience', n: '04' },
        { name: 'İletişim', to: 'contact', n: '05' },
      ],
      available: 'Müsait',
      menu: 'Menü',
      close: 'Kapat',
      backToTop: 'Başa Dön',
    },
    hero: {
      portfolio: 'Portfolyo',
      eduline: 'Bilgisayar Prog. · YBS',
      lead: {
        pre: 'Merhaba. Mobil ve web için ölçeklenebilir, ',
        accent: 'AI entegrasyonlu',
        post: ' ürünler tasarlayıp geliştiriyorum.',
      },
      paragraph:
        'Bilgisayar Programcılığı mezunu ve Yönetim Bilişim Sistemleri öğrencisi olarak, React Native Expo ve PHP Laravel teknolojilerinde uzmanlaşmış 2+ yıllık deneyime sahip bir yazılım geliştiriciyim. AI entegrasyonlu uygulamalardan finans platformlarına kadar geniş bir yelpazede projeler geliştirdim.',
      downloadCV: 'CV İndir',
      viewProjects: 'Projeleri Gör',
      meta: [
        { k: 'Rol', v: 'Full Stack & Mobile Developer' },
        { k: 'Konum', v: 'İstanbul, Türkiye · Gouda, Hollanda' },
        { k: 'Deneyim', v: '2+ Yıl' },
        { k: 'Durum', v: 'Yeni Projelere Açık' },
      ],
    },
    about: {
      label: '(01) Hakkımda',
      tag: 'Full Stack & Mobile Developer',
      lead: {
        pre: 'Bilgisayar Programcılığı mezunu ve Yönetim Bilişim Sistemleri öğrencisi olarak, full-stack ve mobil uygulama geliştirme alanında ',
        accent: '2+ yıllık deneyime',
        post: ' sahip bir yazılım geliştiriciyim.',
      },
      paragraphs: [
        'React Native Expo ve PHP Laravel teknolojilerinde uzmanlaşmış olup, AI entegrasyonlu uygulamalardan finans platformlarına kadar geniş bir yelpazede projeler geliştirdim.',
        'Freelance çalışmalarımda müşteri odaklı çözümler üretirken, kurumsal deneyimlerimde takım çalışması ve agile metodolojiler ile ölçeklenebilir uygulamalar hayata geçirdim. Sürekli öğrenme tutkusu ve yeni teknolojilere hızlı adaptasyon yeteneğimle, inovatif mobil ve web çözümleri geliştirmeyi hedefliyorum.',
      ],
      stats: [
        { number: '6+', label: 'Proje Tamamlandı' },
        { number: '5+', label: 'Mobil Uygulama' },
        { number: '4+', label: 'Web Uygulaması' },
        { number: '2+', label: 'Yıl Deneyim' },
      ],
      skillsTitle: 'Yetkinliklerim',
      skillsSub: 'Temel Yetenek Seviyeleri',
      skills: [
        { name: 'React Native Expo', percentage: 95 },
        { name: 'PHP Laravel', percentage: 90 },
        { name: 'HTML/CSS', percentage: 85 },
        { name: 'MySQL/PostgreSQL', percentage: 80 },
        { name: 'Figma UI/UX', percentage: 75 },
        { name: 'Git', percentage: 85 },
      ],
      othersLabel: 'Diğer Yetkinlikler',
      others: ['WebSocket', 'gRPC', 'RESTful API', 'Push Notification', 'In App Purchase', 'OAuth'],
      eduTitle: 'Eğitim',
      education: [
        { school: 'Anadolu Üniversitesi', program: 'Yönetim Bilişim Sistemleri', period: '2024 — Halen' },
        { school: 'Haliç Üniversitesi', program: 'Bilgisayar Programcılığı', period: '2021 — 2023' },
      ],
      principles: [
        { icon: 'target', title: 'Müşteri Odaklı', text: 'Freelance çalışmalarımda müşteri ihtiyaçlarını analiz ederek özel çözümler üretiyorum.' },
        { icon: 'users', title: 'Agile Metodoloji', text: 'Scrum ve Agile metodolojileri ile takım çalışmasında etkili iletişim kuruyorum.' },
        { icon: 'code', title: 'Sürekli Öğrenme', text: 'Yeni teknolojilere hızlı adaptasyon yeteneğimle sürekli kendimi geliştiriyorum.' },
      ],
    },
    skills: {
      label: '(02) Yetkinlikler',
      tag: 'Teknik Uzmanlık',
      h2: { pre: 'Ne ile ', accent: 'inşa', post: ' ediyorum.' },
      categories: [
        { id: 'programming', name: 'Programlama' },
        { id: 'technologies', name: 'Teknolojiler' },
        { id: 'mobile', name: 'Mobile' },
        { id: 'database', name: 'Veritabanı' },
      ],
      othersLabel: 'Diğer Yetkinlikler',
      others: [
        'Git', 'Figma', 'UI/UX Design', 'Agile', 'Scrum', 'Code Review',
        'API Integration', 'ChatGPT API', 'OAuth', 'WebSocket', 'gRPC', 'RESTful API',
      ],
      coreLabel: 'Temel Yetkinliklerim',
      competencies: [
        { title: 'React Native Expo ile mobil geliştirme', description: 'Cross-platform mobil uygulama geliştirme' },
        { title: 'PHP Laravel ile backend geliştirme', description: 'Güçlü backend API ve servisler' },
        { title: 'HTML, CSS ile arayüz kodlama', description: 'Modern ve responsive web arayüzleri' },
        { title: 'Figma ile UI/UX arayüz tasarlama', description: 'Kullanıcı odaklı tasarım' },
      ],
    },
    projects: {
      label: '(03) Projeler',
      selected: 'Seçili Çalışmalar',
      h2: { pre: 'Seçili ', accent: 'çalışmalar', post: '.' },
      filters: [
        { id: 'all', name: 'Tümü' },
        { id: 'mobile', name: 'Mobil' },
        { id: 'ai', name: 'AI' },
      ],
      featuresLabel: 'Özellikler',
      catMobile: 'Mobil',
      catAi: 'AI / Mobil',
      ctaText: 'Daha fazla proje görmek ister misiniz?',
      ctaBtn: "GitHub'da Görüntüle",
      items: [
        {
          id: 1,
          title: 'Roambit — eSIM App',
          category: 'mobile',
          description: 'Yurt içi ve yurt dışı kullanıcılar için geliştirilen dijital eSIM satın alma ve yönetim uygulaması. Güvenli ödeme altyapısı ve hızlı aktivasyon odaklı mobil uygulama.',
          technologies: ['React Native Expo', 'Stripe', 'QR Code', 'UI/UX Design'],
          features: [
            'Stripe entegrasyonu ile güvenli ödeme sistemi',
            'eSIM plan listeleme ve satın alma akışı',
            'QR kod ile eSIM aktivasyonu',
            'Kullanıcı hesap ve satın alma yönetimi',
            'React Native Expo ile cross-platform geliştirme',
            'Mobil odaklı sade ve kullanıcı dostu UI/UX',
          ],
        },
        {
          id: 2,
          title: 'YOFA App (Your Own Finance App)',
          category: 'mobile',
          description: 'Full-Stack Fintech uygulaması prototipi. React Native Expo ve Laravel teknolojileri kullanılarak yapıldı.',
          technologies: ['React Native Expo', 'Laravel', 'MySQL', 'QR Code', 'OAuth'],
          features: [
            'MCC kod tabanlı harcama kategorilendirme',
            'QR kod ödeme sistemi implementasyonu',
            'Transaction işlemleri',
            'Çoklu kart yönetim sistemi',
            'Kişisel finans analizi ve raporlama',
            'Temel düzeyde Fraud önlemleri',
            'OAuth işlemleri',
          ],
        },
        {
          id: 3,
          title: 'Themis Akademi',
          category: 'mobile',
          description: 'Hukuk profesyonelleri ve adayları için gerçek zamanlı yarışma ve eğitim platformu. Avukat, savcı, hakim ve hazırlık öğrencilerinin bilgi yarışmalarına katılıp ödül kazanabileceği interaktif mobil uygulama.',
          technologies: ['React Native Expo', 'Laravel', 'WebSocket', 'Push Notification', 'In App Purchase'],
          features: [
            'Socket tabanlı canlı etkileşim',
            'UI/UX tasarımı',
            'Web ve Mobil arayüz geliştirilmesi',
            'Push Notification',
            'Sosyal medya ile giriş',
            'In App Purchase',
          ],
        },
        {
          id: 4,
          title: 'Yargı AI',
          category: 'ai',
          description: 'Avukatların dava süreçlerini AI teknolojisi ile optimize etmelerine yardımcı olan yenilikçi mobil platform. Emsal kararlar ve yapay zeka analizi ile dava stratejilerinin geliştirilmesini destekler.',
          technologies: ['React Native Expo', 'Laravel', 'ChatGPT API', 'Push Notification'],
          features: [
            'ChatGPT ile entegre olarak dava analizi',
            'UI/UX tasarımı',
            'Push Notification',
          ],
        },
        {
          id: 5,
          title: 'Taget',
          category: 'ai',
          description: 'Profesyonel iş dünyası için geliştirilmiş dijital kartvizit mobil uygulaması. Kişi ve kuruluşların kendilerini etkili bir şekilde tanıtabilmelerini ve networking yapabilmelerini sağlayan platform. AI destekli chatbot entegrasyonu ile kullanıcı deneyimi optimize edilmiştir.',
          technologies: ['React Native Expo', 'Laravel', 'ChatGPT API', 'UI/UX Design'],
          features: [
            'UI/UX tasarımı',
            'ChatGPT ile entegre olarak chatbot geliştirme',
          ],
        },
        {
          id: 6,
          title: 'Qampus',
          category: 'mobile',
          description: 'Üniversite öğrencilerine yönelik kapsamlı sosyalleşme ve akademik destek platformu. Not paylaşım sistemi, sosyal etkileşim ve öğrenci ayrıcalıkları sunan mobil uygulama.',
          technologies: ['React Native Expo', 'Laravel', 'Push Notification', 'Multi-panel'],
          features: [
            'UI/UX tasarımı',
            'Push Notification',
            'Çoklu panel yönetimi',
          ],
        },
        {
          id: 7,
          title: 'Haliç Üniversitesi Öğrenci Bilgi Sistemi',
          category: 'mobile',
          description: 'Bitirme projesi olarak Haliç Üniversitesi öğrencilerinin ders bilgilerini ve okulla ilgili diğer bilgileri takip edebileceği bir mobil uygulama.',
          technologies: ['Flutter', 'Firebase', 'UI/UX Design'],
          features: [
            'UI/UX tasarımı',
            'Firebase ile backend mimarisi oluşturma',
            'Arayüz geliştirme',
          ],
        },
      ],
    },
    experience: {
      label: '(04) Deneyim',
      range: '2022 — 2026',
      h2: { pre: 'Kariyer ', accent: 'yolculuğu', post: '.' },
      items: [
        {
          id: 5,
          title: 'Full Stack Developer',
          company: 'CodeLabs B.V.',
          location: 'Gouda, Hollanda',
          period: 'Şubat 2026 — Halen',
          description: 'React, React Native ve Laravel teknolojileri kullanarak web çözümleri geliştiriyorum.',
          technologies: ['React', 'React Native', 'Laravel', 'JavaScript', 'MySQL'],
          achievements: [
            'React ile modern web arayüzleri geliştirme',
            'React Native ile cross-platform mobil geliştirme',
            'Laravel ile backend servisleri ve API geliştirme',
            'Uçtan uca web çözümleri',
          ],
        },
        {
          id: 1,
          title: 'Freelancer Full Stack & Mobile Developer',
          company: 'Freelance',
          location: 'İstanbul, Türkiye · Gouda, Hollanda',
          period: 'Şubat 2024 — Halen',
          description: 'Full stack ve mobil uygulama geliştirme alanında çeşitli projelerde çalışarak müşteri ihtiyaçlarını karşılamaktayım. Proje yönetiminden deployment sürecine kadar end-to-end çözümler sunuyorum.',
          technologies: ['React Native Expo', 'PHP Laravel', 'MySQL', 'PostgreSQL', 'Git'],
          achievements: [
            'Mobil uygulama geliştirme ve API entegrasyonları',
            'Veritabanı tasarımı ve optimizasyonu',
            'Müşteri gereksinimleri analizi ve teknik çözüm önerileri',
            'Proje timeline yönetimi ve deployment süreçleri',
          ],
        },
        {
          id: 2,
          title: 'Mobile Developer (React Native Expo)',
          company: 'BCODE',
          location: 'İstanbul, Türkiye',
          period: 'Ekim 2024 — Nisan 2025',
          description: 'Sağlık sektörü özelinde mobil ve web tabanlı uygulamalar geliştirme.',
          technologies: ['React Native Expo', 'Laravel', 'MySQL', 'Agile', 'Scrum'],
          achievements: [
            'React Native ile cross-platform mobil uygulama geliştirme',
            'Laravel backend servislerinin API entegrasyonları',
            'Agile ve Scrum metodoloji ile takım çalışması',
            'Code review ile takımla kolaborasyon',
          ],
        },
        {
          id: 3,
          title: 'Mobile Developer (React Native Expo)',
          company: 'Taget Bilişimleri',
          location: 'İstanbul, Türkiye',
          period: 'Temmuz 2024 — Eylül 2024',
          description: 'Dijital kartvizit sistemi ve iş dünyası uygulamaları geliştirme süreçlerinde aktif rol aldım. Kullanıcı deneyimi odaklı mobil çözümler geliştirdim.',
          technologies: ['React Native Expo', 'Laravel', 'ChatGPT API', 'Agile', 'Scrum'],
          achievements: [
            'React Native ile cross-platform mobil uygulama geliştirme',
            'Laravel backend servislerinin API entegrasyonları',
            'Agile ve Scrum metodoloji ile takım çalışması',
            'Code review ile takımla kolaborasyon',
            'AI entegrasyonlu chatbot sistemi geliştirme',
          ],
        },
        {
          id: 4,
          title: 'Web Developer',
          company: 'Senkron Yazılım',
          location: 'İstanbul, Türkiye',
          period: 'Ağustos 2022 — Ekim 2022',
          description: 'Web teknolojileri konusunda temel deneyim kazandım. Frontend ve tasarım becerilerimi geliştirdim.',
          technologies: ['HTML', 'CSS', 'JavaScript', 'UI/UX Design'],
          achievements: [
            'UI/UX dizayn',
            'Frontend geliştirme',
            'Takım çalışması ve iletişim becerileri',
          ],
        },
      ],
      eduTitle: 'Eğitim',
      education: [
        {
          id: 1,
          degree: 'Yönetim Bilişim Sistemleri',
          school: 'Anadolu Üniversitesi',
          location: 'Eskişehir, Türkiye',
          period: '2024 — Halen',
          description: 'Yönetim bilişim sistemleri alanında lisans eğitimine devam ediyorum.',
        },
        {
          id: 2,
          degree: 'Bilgisayar Programcılığı',
          school: 'Haliç Üniversitesi',
          location: 'İstanbul, Türkiye',
          period: '2021 — 2023',
          description: 'Bilgisayar programcılığı alanında ön lisans eğitimini tamamladım. Bitirme projesi olarak Haliç Üniversitesi Öğrenci Bilgi Sistemi Uygulaması geliştirdim.',
          technologies: ['Flutter', 'Firebase', 'UI/UX Design'],
        },
      ],
      certTitle: 'Sertifika & Eğitimler',
      certifications: [
        { name: 'React Native Development Bootcamp', issuer: 'Online Platform', date: '2024', description: 'React Native ile mobil uygulama geliştirme konusunda kapsamlı eğitim' },
        { name: 'Laravel Advanced Techniques', issuer: 'Online Platform', date: '2024', description: "Laravel framework'ün ileri seviye özellikleri ve best practice'ler" },
        { name: 'İleri Girişimcilik Sertifikası', issuer: 'Girişimcilik Merkezi', date: '2023', description: 'Girişimcilik ve iş geliştirme konularında ileri seviye eğitim' },
      ],
    },
    contact: {
      label: '(05) İletişim',
      location: 'İstanbul, Türkiye · Gouda, Hollanda',
      lets: 'Hadi konuşalım',
      paragraph:
        'Projeniz hakkında konuşmak veya işbirliği yapmak istiyorsanız, benimle iletişime geçmekten çekinmeyin. Size en kısa sürede dönüş yapacağım.',
      socials: [
        { name: 'GitHub', handle: '@yigitavaz', url: 'https://github.com/yigitavaz' },
        { name: 'LinkedIn', handle: 'in/yigitavaz', url: 'https://linkedin.com/in/yigitavaz' },
        { name: 'Instagram', handle: '@yigitavz', url: 'https://instagram.com/yigitavz' },
      ],
    },
    footer: {
      tagline: 'Full Stack & Mobile Developer. Modern mobil ve web çözümleri geliştiriyorum.',
      menu: 'Menü',
      technologies: 'Teknolojiler',
      social: 'Sosyal',
      rights: 'Tüm hakları saklıdır',
      made: 'Made by YA',
    },
  },

  en: {
    nav: {
      items: [
        { name: 'About', to: 'about', n: '01' },
        { name: 'Skills', to: 'skills', n: '02' },
        { name: 'Projects', to: 'projects', n: '03' },
        { name: 'Experience', to: 'experience', n: '04' },
        { name: 'Contact', to: 'contact', n: '05' },
      ],
      available: 'Available',
      menu: 'Menu',
      close: 'Close',
      backToTop: 'Back to Top',
    },
    hero: {
      portfolio: 'Portfolio',
      eduline: 'Computer Prog. · MIS',
      lead: {
        pre: 'Hello. I design and build scalable, ',
        accent: 'AI-integrated',
        post: ' products for mobile and web.',
      },
      paragraph:
        "As a Computer Programming graduate and Management Information Systems student, I'm a software developer with 2+ years of experience specialized in React Native Expo and PHP Laravel. I've built projects across a wide range — from AI-integrated apps to fintech platforms.",
      downloadCV: 'Download CV',
      viewProjects: 'View Projects',
      meta: [
        { k: 'Role', v: 'Full Stack & Mobile Developer' },
        { k: 'Location', v: 'Istanbul, Türkiye · Gouda, Netherlands' },
        { k: 'Experience', v: '2+ Years' },
        { k: 'Status', v: 'Open to New Projects' },
      ],
    },
    about: {
      label: '(01) About',
      tag: 'Full Stack & Mobile Developer',
      lead: {
        pre: "As a Computer Programming graduate and Management Information Systems student, I'm a software developer with ",
        accent: '2+ years of experience',
        post: ' in full-stack and mobile app development.',
      },
      paragraphs: [
        "Specialized in React Native Expo and PHP Laravel, I've developed projects across a broad spectrum — from AI-integrated apps to fintech platforms.",
        'In my freelance work I deliver client-focused solutions, while in corporate roles I have shipped scalable applications through teamwork and agile methodologies. With a passion for continuous learning and quick adaptation to new technologies, I aim to build innovative mobile and web solutions.',
      ],
      stats: [
        { number: '6+', label: 'Projects Completed' },
        { number: '5+', label: 'Mobile Apps' },
        { number: '4+', label: 'Web Apps' },
        { number: '2+', label: 'Years Experience' },
      ],
      skillsTitle: 'My Skills',
      skillsSub: 'Core Proficiency Levels',
      skills: [
        { name: 'React Native Expo', percentage: 95 },
        { name: 'PHP Laravel', percentage: 90 },
        { name: 'HTML/CSS', percentage: 85 },
        { name: 'MySQL/PostgreSQL', percentage: 80 },
        { name: 'Figma UI/UX', percentage: 75 },
        { name: 'Git', percentage: 85 },
      ],
      othersLabel: 'Other Skills',
      others: ['WebSocket', 'gRPC', 'RESTful API', 'Push Notification', 'In App Purchase', 'OAuth'],
      eduTitle: 'Education',
      education: [
        { school: 'Anadolu University', program: 'Management Information Systems', period: '2024 — Present' },
        { school: 'Haliç University', program: 'Computer Programming', period: '2021 — 2023' },
      ],
      principles: [
        { icon: 'target', title: 'Client-Focused', text: 'In my freelance work I analyze client needs and craft tailored solutions.' },
        { icon: 'users', title: 'Agile Methodology', text: 'I communicate effectively in teamwork using Scrum and Agile methodologies.' },
        { icon: 'code', title: 'Continuous Learning', text: 'I keep improving myself with my ability to quickly adapt to new technologies.' },
      ],
    },
    skills: {
      label: '(02) Skills',
      tag: 'Technical Expertise',
      h2: { pre: 'What I ', accent: 'build', post: ' with.' },
      categories: [
        { id: 'programming', name: 'Programming' },
        { id: 'technologies', name: 'Technologies' },
        { id: 'mobile', name: 'Mobile' },
        { id: 'database', name: 'Database' },
      ],
      othersLabel: 'Other Skills',
      others: [
        'Git', 'Figma', 'UI/UX Design', 'Agile', 'Scrum', 'Code Review',
        'API Integration', 'ChatGPT API', 'OAuth', 'WebSocket', 'gRPC', 'RESTful API',
      ],
      coreLabel: 'Core Competencies',
      competencies: [
        { title: 'Mobile development with React Native Expo', description: 'Cross-platform mobile app development' },
        { title: 'Backend development with PHP Laravel', description: 'Robust backend APIs and services' },
        { title: 'Interface coding with HTML, CSS', description: 'Modern and responsive web interfaces' },
        { title: 'UI/UX design with Figma', description: 'User-focused design' },
      ],
    },
    projects: {
      label: '(03) Projects',
      selected: 'Selected Work',
      h2: { pre: 'Selected ', accent: 'work', post: '.' },
      filters: [
        { id: 'all', name: 'All' },
        { id: 'mobile', name: 'Mobile' },
        { id: 'ai', name: 'AI' },
      ],
      featuresLabel: 'Features',
      catMobile: 'Mobile',
      catAi: 'AI / Mobile',
      ctaText: 'Want to see more projects?',
      ctaBtn: 'View on GitHub',
      items: [
        {
          id: 1,
          title: 'Roambit — eSIM App',
          category: 'mobile',
          description: 'A digital eSIM purchase and management app built for domestic and international users. A mobile app focused on secure payment infrastructure and fast activation.',
          technologies: ['React Native Expo', 'Stripe', 'QR Code', 'UI/UX Design'],
          features: [
            'Secure payment system with Stripe integration',
            'eSIM plan listing and purchase flow',
            'eSIM activation via QR code',
            'User account and purchase management',
            'Cross-platform development with React Native Expo',
            'Clean, mobile-first, user-friendly UI/UX',
          ],
        },
        {
          id: 2,
          title: 'YOFA App (Your Own Finance App)',
          category: 'mobile',
          description: 'A full-stack fintech app prototype. Built using React Native Expo and Laravel.',
          technologies: ['React Native Expo', 'Laravel', 'MySQL', 'QR Code', 'OAuth'],
          features: [
            'MCC code-based spending categorization',
            'QR code payment system implementation',
            'Transaction operations',
            'Multi-card management system',
            'Personal finance analysis and reporting',
            'Basic fraud prevention measures',
            'OAuth operations',
          ],
        },
        {
          id: 3,
          title: 'Themis Akademi',
          category: 'mobile',
          description: 'A real-time competition and education platform for legal professionals and candidates. An interactive mobile app where lawyers, prosecutors, judges and exam candidates can join knowledge quizzes and win prizes.',
          technologies: ['React Native Expo', 'Laravel', 'WebSocket', 'Push Notification', 'In App Purchase'],
          features: [
            'Socket-based live interaction',
            'UI/UX design',
            'Web and mobile interface development',
            'Push notifications',
            'Social media login',
            'In-app purchase',
          ],
        },
        {
          id: 4,
          title: 'Yargı AI',
          category: 'ai',
          description: 'An innovative mobile platform that helps lawyers optimize their litigation processes with AI. It supports the development of case strategies through precedent rulings and AI analysis.',
          technologies: ['React Native Expo', 'Laravel', 'ChatGPT API', 'Push Notification'],
          features: [
            'Case analysis integrated with ChatGPT',
            'UI/UX design',
            'Push notifications',
          ],
        },
        {
          id: 5,
          title: 'Taget',
          category: 'ai',
          description: 'A digital business card mobile app built for the professional world. A platform that lets individuals and organizations present themselves effectively and network. The user experience is optimized with an AI-powered chatbot integration.',
          technologies: ['React Native Expo', 'Laravel', 'ChatGPT API', 'UI/UX Design'],
          features: [
            'UI/UX design',
            'Chatbot development integrated with ChatGPT',
          ],
        },
        {
          id: 6,
          title: 'Qampus',
          category: 'mobile',
          description: 'A comprehensive socialization and academic support platform for university students. A mobile app offering a notes-sharing system, social interaction and student perks.',
          technologies: ['React Native Expo', 'Laravel', 'Push Notification', 'Multi-panel'],
          features: [
            'UI/UX design',
            'Push notifications',
            'Multi-panel management',
          ],
        },
        {
          id: 7,
          title: 'Haliç University Student Information System',
          category: 'mobile',
          description: 'A graduation project: a mobile app where Haliç University students can track their course information and other school-related details.',
          technologies: ['Flutter', 'Firebase', 'UI/UX Design'],
          features: [
            'UI/UX design',
            'Building backend architecture with Firebase',
            'Interface development',
          ],
        },
      ],
    },
    experience: {
      label: '(04) Experience',
      range: '2022 — 2026',
      h2: { pre: 'Career ', accent: 'journey', post: '.' },
      items: [
        {
          id: 5,
          title: 'Full Stack Developer',
          company: 'CodeLabs B.V.',
          location: 'Gouda, Netherlands',
          period: 'Feb 2026 — Present',
          description: 'I build web solutions using React, React Native and Laravel.',
          technologies: ['React', 'React Native', 'Laravel', 'JavaScript', 'MySQL'],
          achievements: [
            'Developing modern web interfaces with React',
            'Cross-platform mobile development with React Native',
            'Backend services and API development with Laravel',
            'End-to-end web solutions',
          ],
        },
        {
          id: 1,
          title: 'Freelancer Full Stack & Mobile Developer',
          company: 'Freelance',
          location: 'Istanbul, Türkiye · Gouda, Netherlands',
          period: 'Feb 2024 — Present',
          description: 'I meet client needs by working on various projects in full-stack and mobile app development. I deliver end-to-end solutions from project management to deployment.',
          technologies: ['React Native Expo', 'PHP Laravel', 'MySQL', 'PostgreSQL', 'Git'],
          achievements: [
            'Mobile app development and API integrations',
            'Database design and optimization',
            'Client requirements analysis and technical solution proposals',
            'Project timeline management and deployment processes',
          ],
        },
        {
          id: 2,
          title: 'Mobile Developer (React Native Expo)',
          company: 'BCODE',
          location: 'Istanbul, Türkiye',
          period: 'Oct 2024 — Apr 2025',
          description: 'Developing mobile and web-based applications specifically for the healthcare sector.',
          technologies: ['React Native Expo', 'Laravel', 'MySQL', 'Agile', 'Scrum'],
          achievements: [
            'Cross-platform mobile app development with React Native',
            'API integrations of Laravel backend services',
            'Teamwork with Agile and Scrum methodologies',
            'Collaboration with the team via code review',
          ],
        },
        {
          id: 3,
          title: 'Mobile Developer (React Native Expo)',
          company: 'Taget Bilişimleri',
          location: 'Istanbul, Türkiye',
          period: 'Jul 2024 — Sep 2024',
          description: 'I took an active role in developing a digital business card system and business-world applications. I built user-experience-focused mobile solutions.',
          technologies: ['React Native Expo', 'Laravel', 'ChatGPT API', 'Agile', 'Scrum'],
          achievements: [
            'Cross-platform mobile app development with React Native',
            'API integrations of Laravel backend services',
            'Teamwork with Agile and Scrum methodologies',
            'Collaboration with the team via code review',
            'Developing an AI-integrated chatbot system',
          ],
        },
        {
          id: 4,
          title: 'Web Developer',
          company: 'Senkron Yazılım',
          location: 'Istanbul, Türkiye',
          period: 'Aug 2022 — Oct 2022',
          description: 'I gained foundational experience in web technologies. I improved my frontend and design skills.',
          technologies: ['HTML', 'CSS', 'JavaScript', 'UI/UX Design'],
          achievements: [
            'UI/UX design',
            'Frontend development',
            'Teamwork and communication skills',
          ],
        },
      ],
      eduTitle: 'Education',
      education: [
        {
          id: 1,
          degree: 'Management Information Systems',
          school: 'Anadolu University',
          location: 'Eskişehir, Türkiye',
          period: '2024 — Present',
          description: 'Pursuing a bachelor\'s degree in management information systems.',
        },
        {
          id: 2,
          degree: 'Computer Programming',
          school: 'Haliç University',
          location: 'Istanbul, Türkiye',
          period: '2021 — 2023',
          description: 'Completed an associate degree in computer programming. For my graduation project I developed the Haliç University Student Information System app.',
          technologies: ['Flutter', 'Firebase', 'UI/UX Design'],
        },
      ],
      certTitle: 'Certificates & Training',
      certifications: [
        { name: 'React Native Development Bootcamp', issuer: 'Online Platform', date: '2024', description: 'Comprehensive training on mobile app development with React Native' },
        { name: 'Laravel Advanced Techniques', issuer: 'Online Platform', date: '2024', description: 'Advanced features and best practices of the Laravel framework' },
        { name: 'Advanced Entrepreneurship Certificate', issuer: 'Entrepreneurship Center', date: '2023', description: 'Advanced training in entrepreneurship and business development' },
      ],
    },
    contact: {
      label: '(05) Contact',
      location: 'Istanbul, Türkiye · Gouda, Netherlands',
      lets: "Let's talk",
      paragraph:
        "If you'd like to talk about your project or collaborate, don't hesitate to reach out. I'll get back to you as soon as possible.",
      socials: [
        { name: 'GitHub', handle: '@yigitavaz', url: 'https://github.com/yigitavaz' },
        { name: 'LinkedIn', handle: 'in/yigitavaz', url: 'https://linkedin.com/in/yigitavaz' },
        { name: 'Instagram', handle: '@yigitavz', url: 'https://instagram.com/yigitavz' },
      ],
    },
    footer: {
      tagline: 'Full Stack & Mobile Developer. I build modern mobile and web solutions.',
      menu: 'Menu',
      technologies: 'Technologies',
      social: 'Social',
      rights: 'All rights reserved',
      made: 'Made by YA',
    },
  },
};

// Language-neutral skill data (numbers + tech names) shared by both languages.
export const skillsData = {
  programming: [
    { name: 'JavaScript', level: 90 },
    { name: 'PHP', level: 85 },
    { name: 'Dart', level: 75 },
    { name: 'HTML', level: 95 },
    { name: 'CSS', level: 90 },
  ],
  technologies: [
    { name: 'React.js', level: 85 },
    { name: 'React Native Expo', level: 95 },
    { name: 'Flutter', level: 80 },
    { name: 'Angular', level: 60 },
    { name: 'Laravel', level: 80 },
    { name: 'Node.js', level: 70 },
  ],
  mobile: [
    { name: 'React Native Expo', level: 95 },
    { name: 'Push Notification', level: 85 },
    { name: 'In App Purchase', level: 80 },
    { name: 'Mobile UI/UX', level: 85 },
    { name: 'Cross-platform', level: 90 },
    { name: 'App Store Deployment', level: 90 },
  ],
  database: [
    { name: 'MySQL', level: 85 },
    { name: 'PostgreSQL', level: 80 },
    { name: 'RESTful API', level: 90 },
    { name: 'gRPC', level: 75 },
    { name: 'WebSocket', level: 80 },
    { name: 'Database Design', level: 85 },
  ],
};
